/* global axios */
import ApiClient from './ApiClient';

class BulkActionsSettingsAPI extends ApiClient {
    constructor() {
        super('bulk_auto_actions', { accountScoped: true });
    }

    get(params = {}) {
        return axios.get(this.url, { params });
    }

    preview(payload) {
        return axios.post(`${this.url}/preview`, payload);
    }

    update(id, payload) {
        return axios.patch(`${this.url}/${id}`, payload);
    }

    delete(id) {
        return axios.delete(`${this.url}/${id}`);
    }

    report(id) {
        return axios.get(`${this.url}/${id}/report`);
    }
}

export default new BulkActionsSettingsAPI();
